export default __webpack_public_path__ + "static/media/engage-full-white.dde62bfe.svg";